import { useArticlesEntrypoints } from '@dealstack/frontend/app/pages/HelpBlog/api/useArticlesEntrypoints.ts';
import { ROUTES } from '@dealstack/frontend/app/pages/Routing/routes.ts';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import {
	useCurrentLanguage,
	useTranslationHelpBlog,
} from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { pathMatchPage } from '@dealstack/frontend/shared/utils/pathMatchPage.ts';
import { ApplicationType, EntrypointArticlesRes } from '@dealstack/shared/lib/generated';
import { Button, Text } from '@mantine/core';
import { useMemo } from 'react';
import { generatePath, Link, useLocation, useParams } from 'react-router-dom';

interface Props {
	dataset: ApplicationType;
}

export const HelpBlogButton = ({ dataset }: Props) => {
	const currentLanguage = useCurrentLanguage();
	const tHelpBlog = useTranslationHelpBlog();
	const { pathname } = useLocation();
	const { articlesEntrypoints } = useArticlesEntrypoints(dataset, currentLanguage);
	const { dealId: dealIdParam } = useParams<{ dealId: string }>();
	const dealId = dataset === ApplicationType.DEALSTACK ? dealIdParam : undefined;

	const slugRoute = useMemo(() => {
		if (pathname === ROUTES.DASHBOARD || pathname.includes(ROUTES.HELP_BLOG)) {
			return '';
		}

		const pathMatchedArticle = pathMatchPage<EntrypointArticlesRes>(
			pathname,
			articlesEntrypoints
		);

		return pathMatchedArticle?.slug?.current || '';
	}, [pathname, articlesEntrypoints]);

	const fullRoute = useMemo(() => {
		const defaultRoute = `${ROUTES.HELP_BLOG}/${slugRoute}`;

		if (dealId) {
			return generatePath(`${ROUTES.DEAL}${defaultRoute}`, { dealId });
		}

		return defaultRoute;
	}, [slugRoute, dealId]);

	return (
		<Link to={fullRoute}>
			<Button variant="default" size="md" leftSection={<Icon variant="help" size="lg" />}>
				<Text fw={400}>
					{tHelpBlog('helpBlogButton.text', {
						defaultValue: 'Get Help',
					})}
				</Text>
			</Button>
		</Link>
	);
};
